import React, { Component } from 'react';
import styles from './styles.scss';
import CONFIG from '../../config';
import http from '../../helpers/http';
import WSpinner from '../../components/WSpinner/WSpinner';
import WMask from '../../components/WMask/WMask';
import WModal from '../../components/WModal/WModal';
import WWebView from '../../helpers/wwebview';
import UserInfo from '../../helpers/userinfo';
import WFirebase from '../../helpers/firebase';

class Drawing extends Component 
{
  constructor(props){
    super(props);
    this.state = {
      houseid_loading:true,
      show_spinner:true,
      message:null,
      contacts:[],
    };
  }
  componentDidMount(){

    this.pullData()

    UserInfo.pullData((code=100, userinfo={}, reason='發生錯誤，請洽社區物管') => {
        this.setState({ houseid_loading: false });
    })
  }
  pullData(){

    this.setState({ show_spinner: true });

    http.get(
      CONFIG.API_HOST + 'api/v1.3/contact',
      { }, 
      (state, res) => {
        
        this.setState({ show_spinner: false });
        
        if (state === false) { return this.setState({ message: '發生錯誤' }); }

        if (res.code !== 200) { return this.setState({ message: res.reason }); }

        const { contacts = [] }= res.data;

        this.setState({
          message: contacts.length === 0 && "目前沒有資料",
          contacts: contacts
        })
        
      }
    )
  }
  render()
  {
    return (
      <div className={styles.page_container}>
        <div className={'container'}>
          <h1>服務窗口</h1>
          { this.state.contacts && this.state.contacts.map((item, idx) => 
              <section>
                <h1>{item.name}</h1>
                <h2>{item.company}{item.unit}</h2>
                <h3>{item.position}</h3>
                <div onClick={ e => { 
                
                    window.location.href='tel:' + ( item.tel.replace(new RegExp('#', 'g'), ',').replace(new RegExp('[\\(\\)-]', 'g'), '') )

                    WFirebase.logEvent('ContactCustomer_PS',{'CallPhone': UserInfo.houseid})
                  }} >
                  <span name='phone'/>
                    {item.tel}
                </div>
                <div onClick={ e => { 
                    
                    WWebView.openURL('mailto:' + item.mail) 

                    WFirebase.logEvent('ContactCustomer_PS',{'SendEmail': UserInfo.houseid})
                  }} >
                  <span name='mail'/>
                  {item.mail}
                </div>
              </section>
            )
          }
          <section>
            <h1>其它服務</h1>
            <h2>週一～週五 08:30-18:00</h2>
            <div onClick={ e => { 
              window.location.href='tel:+886800033666'

              WFirebase.logEvent('ContactCustomer_PS',{'CallPhone': UserInfo.houseid})
            }} >
              <span name='phone'/>
              0800-033-666
            </div>
            <div onClick={ e => { WWebView.openURL('mailto:ucity@farglory.com.tw') }} >
              <span name='mail'/>
              ucity@farglory.com.tw
            </div>
            <div onClick={ e => { WWebView.openURL('https://lin.ee/rc5ntJQ') }} >
              <button type="button" className="btn btn-line" onClick={ e => { WWebView.openURL('https://lin.ee/rc5ntJQ') }}>
                <span name='line'/>
                加入好友
              </button>
            </div>
          </section>
        </div>
        { (this.state.show_spinner || this.state.houseid_loading) && <WMask><WSpinner/></WMask> }
      </div>
    );
  }
}

export default Drawing;


// WEBPACK FOOTER //
// ./src/views/Contacts/Contacts.js